var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/containers/warning_container.js";
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Warning from '../components/warning';
const APPROX_HASHTAG_RE = /(?:^|[^\/\)\w])#(\w*[a-zA-Z·]\w*)/i;
const mapStateToProps = state => {
  const me = state.get('me');
  return {
    needsLockWarning: state.getIn(['compose', 'privacy']) === 'private' && !state.getIn(['accounts', me, 'locked']),
    hashtagWarning: state.getIn(['compose', 'privacy']) !== 'public' && APPROX_HASHTAG_RE.test(state.getIn(['compose', 'text'])),
    directMessageWarning: state.getIn(['compose', 'privacy']) === 'direct'
  };
};
const WarningWrapper = ({
  needsLockWarning,
  hashtagWarning,
  directMessageWarning
}) => {
  if (needsLockWarning) {
    return /*#__PURE__*/React.createElement(Warning, {
      message: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "compose_form.lock_disclaimer",
        defaultMessage: "Your account is not {locked}. Anyone can follow you to view your follower-only posts.",
        values: {
          locked: /*#__PURE__*/React.createElement(Link, {
            to: "/settings/profile",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 22,
              columnNumber: 203
            }
          }, /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "compose_form.lock_disclaimer.lock",
            defaultMessage: "locked",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 22,
              columnNumber: 232
            }
          }))
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 22,
          columnNumber: 30
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 12
      }
    });
  }
  if (hashtagWarning) {
    return /*#__PURE__*/React.createElement(Warning, {
      message: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "compose_form.hashtag_warning",
        defaultMessage: "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 26,
          columnNumber: 30
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 12
      }
    });
  }
  if (directMessageWarning) {
    const message = /*#__PURE__*/React.createElement("span", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "compose_form.direct_message_warning",
      defaultMessage: "This post will only be sent to the mentioned users.",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 9
      }
    }));
    return /*#__PURE__*/React.createElement(Warning, {
      message: message,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 12
      }
    });
  }
  return null;
};
WarningWrapper.propTypes = {
  needsLockWarning: PropTypes.bool,
  hashtagWarning: PropTypes.bool,
  directMessageWarning: PropTypes.bool
};
export default connect(mapStateToProps)(WarningWrapper);